var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileNavFavList = function SvgMobileNavFavList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobile_nav_fav_list_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".mobile_nav_fav_list_svg__st0{fill:none;stroke:#000;stroke-width:1.3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mobile_nav_fav_list_svg__st0",
    d: "M24.1 21.4c.9-1.6 2.3-2.5 3.8-2.3 1.2.2 2.3 1.2 2.6 1.9 1 2.3-1.6 6.1-6.4 9.5M24.1 21.4c-.9-1.6-2.3-2.5-3.8-2.3-1.2.2-2.3 1.2-2.6 1.9-1 2.3 1.6 6.1 6.4 9.5"
  })));
};
export default SvgMobileNavFavList;